<!--
<div [formGroup]="form">
	 <nz-form-item *ngSwitchCase="'File'">
		<nz-form-label [nzSpan]="6"  [nzRequired]="wrapper.element.required">{{ wrapper.element.name }}</nz-form-label>
		<nz-form-control [nzSpan]="14">
			<input type="file" (change)="onFileSelected($event, wrapper)" />
		</nz-form-control>
	</nz-form-item>
</div>
-->
<div [formGroup]="form">
	<nz-form-item *ngIf="inline == false">
		<nz-form-label [nzSpan]="10" [nzRequired]="wrapper.element.required" nzFor="{{ toControlKey(wrapper.element) }}">
			{{ wrapper.element.name }}
		</nz-form-label>

		<nz-form-control [nzSpan]="10" [nzAutoTips]="wrapper.autoTips">
			<!-- TODO make it readonly -->
			<nz-upload
				[nzDisabled]="readonly"
				nzListType="text"
				[nzMultiple]="false"
				[nzFileList]="fileList"
				[nzCustomRequest]="customUpload"
				(nzRemove)="onRemove()">
				<button nz-button *ngIf="!readonly">
					<span *ngIf="!wrapper.control.valid || !wrapper.control.value" nz-icon nzType="upload"></span>
					<span *ngIf="wrapper.control.valid && wrapper.control.value" nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a"></span>
					<span *ngIf="!wrapper.control.valid || !wrapper.control.value">Click to Upload</span>
					<span *ngIf="wrapper.control.valid && wrapper.control.value">Uploaded</span>
				</button>
				<button nz-button *ngIf="readonly">Upload Disabled</button>
			</nz-upload>
		</nz-form-control>
	</nz-form-item>
	<nz-form-item *ngIf="inline == true">
		<nz-form-control [nzAutoTips]="wrapper.autoTips">
			<!-- TODO make it readonly -->
			<nz-upload
				[nzDisabled]="readonly"
				nzListType="text"
				[nzMultiple]="false"
				[nzFileList]="fileList"
				[nzCustomRequest]="customUpload"
				(nzRemove)="onRemove()">
				<button nz-button *ngIf="!readonly">
					<span *ngIf="!wrapper.control.valid || !wrapper.control.value" nz-icon nzType="upload"></span>
					<span *ngIf="wrapper.control.valid && wrapper.control.value" nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a"></span>
					<span *ngIf="!wrapper.control.valid || !wrapper.control.value">Click to Upload</span>
					<span *ngIf="wrapper.control.valid && wrapper.control.value">Uploaded</span>
				</button>
				<button nz-button *ngIf="readonly">Upload Disabled</button>
			</nz-upload>
		</nz-form-control>
	</nz-form-item>
</div>
